module.exports = __webpack_public_path__ + "img/company9.f93980bb.png";